var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70711 22.2929L7.17678 21.7626L7.70711 22.2929ZM9.42926 20.5707V19.8207H9.1186L8.89893 20.0404L9.42926 20.5707ZM6.75 11C6.75 8.65279 8.65279 6.75 11 6.75V5.25C7.82436 5.25 5.25 7.82436 5.25 11H6.75ZM6.75 20V11H5.25V20H6.75ZM6.75 20.5707V20H5.25V20.5707H6.75ZM6.75 21.5858V20.5707H5.25V21.5858H6.75ZM7.17678 21.7626C7.01928 21.9201 6.75 21.8085 6.75 21.5858H5.25C5.25 23.1449 7.135 23.9257 8.23744 22.8232L7.17678 21.7626ZM8.89893 20.0404L7.17678 21.7626L8.23744 22.8232L9.95959 21.1011L8.89893 20.0404ZM17.9992 19.8207H9.42926V21.3207H17.9992V19.8207ZM22.2492 15.5707C22.2492 17.918 20.3464 19.8207 17.9992 19.8207V21.3207C21.1748 21.3207 23.7492 18.7464 23.7492 15.5707H22.2492ZM22.2492 11V15.5707H23.7492V11H22.2492ZM17.9992 6.75C20.3464 6.75 22.2492 8.65279 22.2492 11H23.7492C23.7492 7.82436 21.1748 5.25 17.9992 5.25V6.75ZM11 6.75H17.9992V5.25H11V6.75Z",
    fill: "#AC92ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.8fd9a637b08b6a9c695ab5856b6abcda.svg";
export { ForwardRef as ReactComponent };